import script from "./ModalGuardarRooming.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalGuardarRooming.vue?vue&type=script&setup=true&lang=js"

import "./ModalGuardarRooming.vue?vue&type=style&index=0&id=547d2147&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-547d2147"]])

export default __exports__